import React, { useState, useEffect } from "react";
import { BookingFormData } from "../types/types";
import { getPriceForDate } from "../utils/pricing.ts";
import "../styles/BookingForm.css";

interface BookingFormProps {
  onSubmit: (formData: BookingFormData) => void;
  startDate: Date | null;
  endDate: Date | null;
}

export const BookingForm: React.FC<BookingFormProps> = ({
  onSubmit,
  startDate,
  endDate,
}) => {
  const [formData, setFormData] = useState<BookingFormData>({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
  });

  const [totalPrice, setTotalPrice] = useState<number>(0);

  useEffect(() => {
    if (startDate && endDate) {
      let total = 0;
      const currentDate = new Date(startDate);

      while (currentDate <= endDate) {
        total += getPriceForDate(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }

      setTotalPrice(total);
    }
  }, [startDate, endDate]);

  const formatDate = (date: Date) => {
    return date.toLocaleDateString("bg-BG", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!startDate || !endDate) {
      alert("Моля изберете дати за резервация!");
      return;
    }
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="booking-form">
      {startDate && endDate && (
        <div className="booking-summary">
          <h3>Детайли за резервацията</h3>
          <p>Дата на настаняване: {formatDate(startDate)}</p>
          <p>
            Дата на напускане:{" "}
            {formatDate(new Date(endDate.getTime() + 24 * 60 * 60 * 1000))}
          </p>
          <p>Обща цена за нощувки: {totalPrice}€</p>
        </div>
      )}

      <div>
        <label>Име:</label>
        <input
          type="text"
          required
          value={formData.firstName}
          onChange={(e) =>
            setFormData({ ...formData, firstName: e.target.value })
          }
        />
      </div>
      <div>
        <label>Фамилия:</label>
        <input
          type="text"
          required
          value={formData.lastName}
          onChange={(e) =>
            setFormData({ ...formData, lastName: e.target.value })
          }
        />
      </div>
      <div>
        <label>Телефон:</label>
        <input
          type="tel"
          required
          value={formData.phone}
          onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
        />
      </div>
      <div>
        <label>Имейл:</label>
        <input
          type="email"
          required
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
        />
      </div>
      <button type="submit">Направи резервация</button>
    </form>
  );
};
